import React, { useMemo } from 'react';
import useQuoteData from "../useQuoteData";
import { Typography } from "@mui/material";
import { useTranslations } from "@fenetech/translations";

const QuoteLegend: React.FC = () => {

    const { requiredFields } = useQuoteData();
    const tm = useTranslations();

    const showLegend = useMemo(() => {
        return requiredFields && requiredFields.length > 0;
    }, [requiredFields]);

    if (showLegend) {
        return <Typography variant="caption">* {tm.Get("Required Quote Fields")}</Typography>
    }
    return <></>;
}

export default QuoteLegend;